import * as React from 'react';
const SvgWhatsapp = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            d='M10 2.628c-3.86 0-7 3.14-7 7 0 1.205.311 2.39.902 3.436l-.89 3.177a.304.304 0 0 0 .365.378l3.317-.821a7 7 0 0 0 3.306.83c3.86 0 7-3.14 7-7s-3.14-7-7-7m3.521 9.47c-.15.414-.868.793-1.213.844a2.5 2.5 0 0 1-1.132-.07c-.26-.083-.596-.192-1.024-.375-1.803-.768-2.98-2.56-3.07-2.68-.09-.118-.734-.961-.734-1.834s.464-1.303.629-1.48a.66.66 0 0 1 .48-.223c.12 0 .239.002.344.006.11.006.259-.041.404.305.15.356.51 1.229.554 1.318s.075.193.015.311-.09.192-.18.296-.188.231-.27.311c-.09.089-.183.185-.078.362.105.178.465.76 1 1.23.686.604 1.265.791 1.445.88.18.09.284.074.39-.044.104-.119.448-.518.568-.696s.24-.148.405-.089c.164.06 1.048.489 1.227.577.18.09.3.134.345.208s.045.429-.105.843'
        />
    </svg>
);
export default SvgWhatsapp;
